import { useNavigate } from 'react-router-dom';
import PaperPlaneBlue from '@Assets/paper_plane_blue.webp';
import PaperPlaneGreen from '@Assets/paper_plane_green.webp';
import PaperPlanePink from '@Assets/paper_plane_pink.webp';
import PaperPlanePurple from '@Assets/paper_plane_purple.webp';
import { ReactComponent as ReportTicket } from '@Assets/report_ticket.svg';
import { ReactComponent as TrackTicket } from '@Assets/track_ticket.svg';
import TopPanel from '@CommonFunctionalDisplay/TopPanel';
import Footer from '@CommonFunctionalDisplay/Footer';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_ComStyles.scss';
import './GetStartedPage.scss';

export default function GetStartedPage() {

    const navigate = useNavigate();
    const className = 'getStartedPage';

    const handleSearchClick = () => {
        navigate('/home/form/search');
//        localStorage.setItem('view', JSON.stringify({ type: 'form', subType: 'search'}));
//        setSearchParams({'type': 'form', 'subType': 'search'})
//        window.dispatchEvent(new Event('storage'));
    };

    const handleTrackClick = () => {
        navigate('/home/track');
//        localStorage.setItem('view', JSON.stringify({ type: 'ticket', subType: 'track'}));
//        setSearchParams({'type': 'ticket', 'subType': 'track'})
//        window.dispatchEvent(new Event('storage'));
    };

    return (
        <div className={className}>
            <TopPanel />
            <div className={className + '__container'}>
                <div className={className + '__content'}>
                    <div className={className + '__hero'}>
                        <div className={className + '__hero__badge'}>
                            <span className={className + '__hero__badge__text'}>✨ Resolve Portal</span>
                        </div>
                        <h1 className={className + '__hero__title'}>
                            Welcome to Resolve
                        </h1>
                        <p className={className + '__hero__subtitle'}>
                            Your centralized hub for efficient ticket management and resolution
                        </p>
                    </div>

                    <div className={className + '__cards'}>
                        <div className={className + '__card ' + className + '__card--track'} onClick={handleTrackClick}>
                            <div className={className + '__card__icon-wrapper ' + className + '__card__icon-wrapper--track'}>
                                <TrackTicket className={className + '__card__icon'}/>
                            </div>
                            <h3 className={className + '__card__title'}>Track Tickets</h3>
                            <p className={className + '__card__description'}>
                                Search for your tickets using Ticket IDs, or view all your reported tickets in one place.
                            </p>
                            <div className={className + '__card__action'}>
                                <span className={className + '__card__action__text'}>Get Started</span>
                                <span className={className + '__card__action__arrow'}>→</span>
                            </div>
                        </div>

                        <div className={className + '__card ' + className + '__card--report'} onClick={handleSearchClick}>
                            <div className={className + '__card__icon-wrapper ' + className + '__card__icon-wrapper--report'}>
                                <ReportTicket className={className + '__card__icon'}/>
                            </div>
                            <h3 className={className + '__card__title'}>Report Issue</h3>
                            <p className={className + '__card__description'}>
                                Submit a new ticket using a Form ID or search for a form by organization name.
                            </p>
                            <div className={className + '__card__action'}>
                                <span className={className + '__card__action__text'}>Get Started</span>
                                <span className={className + '__card__action__arrow'}>→</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={className + '__decorations'}>
                    <img src={PaperPlaneBlue} alt='' className={className + '__decoration ' + className + '__decoration--1'}/>
                    <img src={PaperPlaneGreen} alt='' className={className + '__decoration ' + className + '__decoration--2'}/>
                    <img src={PaperPlanePink} alt='' className={className + '__decoration ' + className + '__decoration--3'}/>
                    <img src={PaperPlanePurple} alt='' className={className + '__decoration ' + className + '__decoration--4'}/>
                    <img src={PaperPlaneBlue} alt='' className={className + '__decoration ' + className + '__decoration--5'}/>
                    <img src={PaperPlaneGreen} alt='' className={className + '__decoration ' + className + '__decoration--6'}/>
                </div>
            </div>
            <Footer />
        </div>
    )
}
